/**
 * Botones flotantes (Escucha a Cheesy y WhatsApp): se esconden cuando hay algo importante a la vista.
 * - El pie de página (datos legales, enlaces) entra en pantalla.
 * - Botones de compra (los de la ficha y todo lo marcado con data-chz-float-avoid) quedan en la franja de
 *   abajo, donde irían los flotantes.
 * - Hay un campo de texto con foco (en el celular, el teclado tapa todo).
 * - En celular y tablet, mientras bajas leyendo (html[data-chz-scroll='down']).
 * Lo marca html[data-chz-float='hide']; los estilos están en assets/chz-base.css. El menú, el carrito y
 * los diálogos abiertos se resuelven solo con CSS.
 */
const root = document.documentElement;
const reasons = new Set();

function update() {
  if (reasons.size) root.dataset.chzFloat = 'hide';
  else delete root.dataset.chzFloat;
}

/** @param {string} reason @param {boolean} on */
function mark(reason, on) {
  if (on) reasons.add(reason);
  else reasons.delete(reason);
  update();
}

if ('IntersectionObserver' in window) {
  const footer = document.querySelector('body > div footer, footer');
  if (footer) {
    new IntersectionObserver(([entry]) => mark('footer', Boolean(entry?.isIntersecting))).observe(footer);
  }

  // Solo la franja de abajo de la pantalla (el último 30%): ahí viven los flotantes.
  const buyButtons = document.querySelectorAll('.buy-buttons-block, [data-chz-float-avoid]');
  if (buyButtons.length) {
    const visible = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        mark('buy', visible.size > 0);
      },
      { rootMargin: '-70% 0px 0px 0px' }
    );
    buyButtons.forEach((element) => observer.observe(element));
  }
}

// En celular y tablet los flotantes tapan texto: se van mientras bajas leyendo y vuelven al subir o arriba
// de todo (html[data-chz-scroll='down']). Si Cheesy está hablando, su botón se queda para poder pararlo (CSS).
const phone = window.matchMedia('(max-width: 989px)');
let lastY = window.scrollY;
let travel = 0;
let queued = false;

function onScroll() {
  queued = false;
  const y = window.scrollY;
  const delta = y - lastY;
  lastY = y;
  if (!phone.matches || y < 160) {
    travel = 0;
    delete root.dataset.chzScroll;
    return;
  }
  // Suma el recorrido en una misma dirección, así no parpadea con cada pixel.
  travel = delta * travel > 0 ? travel + delta : delta;
  if (travel > 40) root.dataset.chzScroll = 'down';
  else if (travel < -40) delete root.dataset.chzScroll;
}

window.addEventListener(
  'scroll',
  () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(onScroll);
  },
  { passive: true }
);

const TYPING = 'input:not([type="checkbox"], [type="radio"], [type="range"], [type="submit"], [type="button"]), textarea, select';

document.addEventListener('focusin', (event) => {
  if (event.target instanceof Element && event.target.matches(TYPING)) mark('typing', true);
});

document.addEventListener('focusout', () => mark('typing', false));
